import Entity from './entity';
export default class Content extends Entity<string> {
  imageFile:any;
  imageName:string;
  title:string;
  text:string;
  contentType:number;
  orderNo:number;
}